import React, { Fragment } from 'react'
import NotifListItem from 'molecules/NotifListItem'
import { TxtLink } from 'atoms/Texts'
import { Card, LastRow } from './styles'

const NotifListCard = ({ isShow, datas, fnRoute, fnSwitch, ...rest }) => {
  const sliced = datas.slice(0, 4)

  return (
    <Card show={isShow ? 'flex' : 'none'}>
      {datas.length > 0 ?
        <Fragment>
          {sliced.map((data, i) =>
            <NotifListItem item={data} key={i} fnSwitch={fnSwitch} />
          )}
        </Fragment> :
        null
      }
      <LastRow>
        <TxtLink href={'#'} size={'14px'} onClick={fnRoute}>
          See more notification
        </TxtLink>
      </LastRow>
    </Card>
  )
}

export default NotifListCard
